import React, { useState } from "react";
import remove from "../../../assets/JoinNow/cancel.svg";
import grp from "../../../assets/Surveys/qualiGroup.svg";
import PropTypes from "prop-types";
import { useAuth } from "context/auth-context";
import { useTranslation } from "react-i18next";

export const QualificationPopUp = ({ ShowPopup, attemptFunction, setSelectedSurveyData }) => {
  const { t } = useTranslation(); 
  const [buttonClicked, setButtonClicked] = useState(false);
  const { auth } = useAuth();
  const panelistId = auth.panelistId;

  const handleAttempt = () => {
    if (!buttonClicked) {
      setButtonClicked(true);
      const payload = {
        affilate: null,
        apiClientId: setSelectedSurveyData.apiClientId,
        isGuestUser: null,
        panelListId: panelistId,
        points: setSelectedSurveyData.finalPoint || setSelectedSurveyData.points,
        sid: setSelectedSurveyData.s_id,
        source: null,
        studyName: setSelectedSurveyData.studyName,
        study_id: setSelectedSurveyData._id,
        v_id: null,
        vid: null,
        vendorCpi: setSelectedSurveyData.vendorCpi,
        loi: setSelectedSurveyData.loi,
      };
      attemptFunction(payload);
    }
  };
  return (
    <div>
      <div className="fixed z-20 sm:top-[80px] inset-0 w-full h-full flex justify-center bg-black bg-opacity-50 pt-10 sm:pt-20 lg:pt-5" onClick={ShowPopup}>
        <div className="bg-white rounded-3xl w-[90%] sm:w-[480px] pb-8 sticky top-[80px] h-fit sm:max-h-[80vh] overflow-y-auto mt-[44px] sm:mt-0">
          <div className=" flex items-center justify-center gap-4 lg:h-[70px] w-full h-[60px] bg-gradient-to-b from-[#8FDCFF42] to-[#1B87B742] relative">
            <span className="text-lg font-medium  font-poppins lg:text-2xl md:text-xl">{t("joinnow.bonus.Qualification")}</span>
            <div
              className="text-[#222020]  lg:w-14 md:w-10 w-6  absolute font-poppins lg:top-4 md:top-4  lg:right-[10px] md:right-[20px] right-5 cursor-pointer"
              onClick={ShowPopup}
            >
              <img src={remove} alt="remove icon" />
            </div>
          </div>
          <div className="flex flex-col items-center mt-2  font-poppins lg:mt-3 md:mt-2">
            <div className="flex flex-col text-[#4E4E4E]  rounded-3xl font-poppins font-normal  items-center justify-center gap-1 mt-3">
              <span className="text-sm font-medium lg:text-lg md:text-base font-poppins">{t("joinnow.bonus.opinion")} </span>
              <span className="text-xs lg:text-sm md:text-xs">{t("joinnow.bonus.completely")}  </span>
            </div>
            <div className="flex lg:gap-4 md:gap-4 gap-2 w-[90%] rounded-2xl  font-poppins mt-4 sm:mt-6 bg-[#056E9C0A] px-4 py-3">
              <div className="w-12 lg:w-20 md:w-16">
                <img src={grp} alt="" />
              </div>
              <div className="flex flex-col gap-1">
                <span className="lg:text-base md:text-sm text-xs font-poppins text-[#4E4E4E]  font-medium">{t("joinnow.bonus.attentive")}</span>
                <div className="text-[#4E4E4E] font-poppins font-normal sm:text-sm text-[0.6rem]">

                  <span>{t("joinnow.bonus.carefully")}</span>
                  <span> {t("joinnow.bonus.quickly")}</span>
                </div>
              </div>

            </div>
            <div className="flex lg:gap-4 md:gap-4 gap-2 w-[90%] rounded-2xl  font-poppins mt-4 sm:mt-6 bg-[#056E9C0A] px-4 py-3">
              <div className="w-12 lg:w-20 md:w-16">
                <img src={grp} alt="" />
              </div>
              <div className="flex flex-col gap-1">
                <span className="lg:text-base md:text-sm text-xs font-poppins text-[#4E4E4E]  font-medium">{t("joinnow.bonus.Be")}</span>
                <div className="text-[#4E4E4E] font-poppins font-normal md:text-sm text-[0.6rem]">

                  <span>{t("joinnow.bonus.accurate")}</span>
                  <span> {t("joinnow.bonus.information")}</span>
                </div>
              </div>

            </div>
            <div className="flex  lg:gap-4 md:gap-4 gap-2 w-[90%] rounded-2xl  font-poppins mt-4 sm:mt-6 bg-[#056E9C0A] px-4 py-3">
              <div className="w-12 lg:w-20 md:w-16">
                <img src={grp} alt="" />
              </div>
              <div className="flex flex-col gap-1">
                <span className="lg:text-base md:text-sm text-xs font-poppins text-[#4E4E4E]  font-medium">{t("joinnow.bonus.patient")}</span>
                <div className="text-[#4E4E4E] font-poppins font-normal md:text-sm text-[0.6rem]">

                  <span>{t("joinnow.bonus.won")}</span>
                  <span> {t("joinnow.bonus.surveys")}</span>
                </div>
              </div>

            </div>

            <button className={`w-52  h-8 lg:w-72 lg:h-14 md:w-64 md:h-12 bg-[#056E9C] lg:text-base md:text-sm text-xs text-white rounded-3xl lg:mt-8 md:mt-6 mt-4 ${buttonClicked ? 'opacity-50 transition-opacity duration-500 cursor-not-allowed' : ""}`}
              disabled={buttonClicked}
              onClick={handleAttempt}>

              {t("joinnow.bonus.Start")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
QualificationPopUp.propTypes = {
  setSelectedSurveyData: PropTypes.object.isRequired,
  attemptFunction: PropTypes.func.isRequired,
  ShowPopup: PropTypes.func.isRequired,
};
